import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FieldFiltering, FieldAddEdit } from './Pages';

export const FieldRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={FieldFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={FieldAddEdit} />
    </Fragment>
)